// Eldora countdown: ticks every [data-eldora-cd] element, rolling each digit as it changes.
// The header bar sets the end time; product page blocks ([data-eldora-cd-follow]) copy it.

const DAY = 86400;
const cairo = new Intl.DateTimeFormat('en-GB', {
  timeZone: 'Africa/Cairo',
  year: 'numeric',
  month: '2-digit',
  day: '2-digit',
  hour: '2-digit',
  minute: '2-digit',
  second: '2-digit',
  hourCycle: 'h23',
});

function cairoParts(date) {
  const parts = {};
  for (const part of cairo.formatToParts(date)) parts[part.type] = Number(part.value);
  return parts;
}

function cairoOffsetMs(date) {
  const p = cairoParts(date);
  return Date.UTC(p.year, p.month - 1, p.day, p.hour % 24, p.minute, p.second) - Math.floor(date.getTime() / 1000) * 1000;
}

// "2026-10-31 23:59" in Cairo time -> epoch ms
function parseCairo(text) {
  const match = /^(\d{4})-(\d{2})-(\d{2})[ T](\d{2}):(\d{2})$/.exec((text || '').trim());
  if (!match) return null;
  const asUtc = Date.UTC(+match[1], +match[2] - 1, +match[3], +match[4], +match[5]);
  return asUtc - cairoOffsetMs(new Date(asUtc));
}

function secondsLeft(config) {
  if (config.mode === 'date') {
    return config.end == null ? -1 : Math.floor((config.end - Date.now()) / 1000);
  }
  // daily: counts down to the reset hour in Cairo, then starts the next 24 hours
  const p = cairoParts(new Date());
  const left = config.reset * 3600 - ((p.hour % 24) * 3600 + p.minute * 60 + p.second);
  return left <= 0 ? left + DAY : left;
}

function setDigit(box, char) {
  const current = box.lastElementChild;
  if (current && current.textContent === char) return;
  const next = document.createElement('span');
  next.className = 'is-in';
  next.textContent = char;
  if (current) {
    current.className = 'is-out';
    setTimeout(() => current.remove(), 450);
  }
  box.append(next);
}

function prepare(el) {
  el.querySelectorAll('[data-unit]').forEach((unit) => {
    const start = unit.textContent.trim().padStart(2, '0');
    unit.textContent = '';
    unit._digits = [...start].map((char) => {
      const box = document.createElement('span');
      box.className = 'eldora-cd__digit';
      const inner = document.createElement('span');
      inner.textContent = char;
      box.append(inner);
      unit.append(box);
      return box;
    });
  });
}

function render(el, seconds) {
  const pad = (n) => String(n).padStart(2, '0');
  const values = {
    h: pad(Math.min(99, Math.floor(seconds / 3600))),
    m: pad(Math.floor((seconds % 3600) / 60)),
    s: pad(seconds % 60),
  };
  el.querySelectorAll('[data-unit]').forEach((unit) => {
    const value = values[unit.dataset.unit];
    setDigit(unit._digits[0], value[0]);
    setDigit(unit._digits[1], value[1]);
  });
  const line = el.querySelector('[data-eldora-cd-line]');
  if (line) line.style.width = `${(Math.min(1, seconds / DAY) * 100).toFixed(2)}%`;
}

function start() {
  const bar = document.querySelector('[data-eldora-cd]:not([data-eldora-cd-follow])');
  const config = bar
    ? { mode: bar.dataset.mode, end: parseCairo(bar.dataset.end), reset: Number(bar.dataset.reset) || 0 }
    : null;
  const timers = [];

  document.querySelectorAll('[data-eldora-cd]').forEach((el) => {
    if (el.dataset.eldoraCdReady) return;
    el.dataset.eldoraCdReady = 'true';
    if (el.hasAttribute('data-eldora-cd-follow')) {
      if (!config || bar.dataset.product !== 'true') return;
      el.hidden = false;
    }
    prepare(el);
    timers.push(el);
  });

  if (!config || timers.length === 0) return;

  const tick = () => {
    const seconds = secondsLeft(config);
    timers.forEach((el) => {
      if (seconds <= 0 && config.mode === 'date') {
        el.hidden = true;
        return;
      }
      render(el, Math.max(0, seconds));
    });
  };
  tick();
  setInterval(tick, 1000);
}

start();
